<script setup lang="ts">
import WidgetRecordAction from '@/components/widget/WidgetRecordAction.vue'

const { items, readonly } = defineProps<{
  items: Array<any>,
  readonly: boolean
}>()

const emit = defineEmits(['removeItem'])
const removeItem = (item: unknown) => emit('removeItem', item)
</script>

<template>
  <div>
    <VList
      lines="one"
      density="compact"
    >
      <VListItem
        v-for="item in items"
        :key="item.Uuid"
        class="px-0"
      >
        <div class="d-flex align-center border-b p-0">
          <RouterLink
            :to="{ name: 'counterparty', params: { uuid: item.Uuid } }"
            :target="readonly ? undefined : '_blank'"
          >
            {{ item.Name }}
          </RouterLink>

          <WidgetRecordAction
            v-if="!readonly"
            class="ml-auto"
            :selected="true"
            view
            @delete="removeItem(item)"
          />
        </div>
      </VListItem>
    </VList>
  </div>
</template>
